import { combineReducers } from 'redux-immutable';
import { proceduresReducer } from 'iguazu-rpc';
import { resourcesReducer } from 'iguazu-rest';
import productsReducer from 'axp-product-ducks';

import { reducer as baseReducers } from '@americanexpress/one-maps-base';

export const reducer = combineReducers({
  procedures: proceduresReducer,
  resources: resourcesReducer,
  products: productsReducer,
  baseReducers,
});

export default reducer;
